
import * as React from "react";
import { Box, Collapse, Divider, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Stack, Typography } from "@mui/material";
import { styled, useTheme } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";

import SettingsIcon from '@mui/icons-material/Settings';
import SwitchAccessShortcutAddIcon from '@mui/icons-material/SwitchAccessShortcutAdd';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SubjectIcon from '@mui/icons-material/Subject';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import RuleIcon from '@mui/icons-material/Rule';
import StarBorder from '@mui/icons-material/StarBorder';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

import { useLoading } from "../../../util/LoadingContext";
import { useProfile } from "../../common/useProfile";
import Service from "../../../util/Service";
import CodeContentPage from "./CodeContentPage";
import ContentPage from "./ContentPage";
import { Inventory } from "@mui/icons-material";

const drawerWidth = 260;

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

export default function LayoutLeft(props) {
    const { window, pageRoot, openD, setOpenD } = props
    const prof = useProfile();
    const [pagina, setPagina] = React.useState();
    const [wait, setWait] = React.useState(false);
    const navigate = useNavigate();
    const theme = useTheme();
    const { setIsLoading } = useLoading();
    const [openSub, setOpenSub] = React.useState(false);
    const [categorias, setCategorias] = React.useState([]);

    React.useEffect(() => {
        if (pageRoot) {
            setWait(true);
            const h = pageRoot.layout.left.pagina || 'Left';
            Service.GET('/api/paginaHtml/buscaPorNome/' + h).then(r => {
                if (r && r.length > 0) {
                    setPagina(r[0]);                    
                }
                setWait(false)
            });
        }
    }, [pageRoot])

    const handleDrawerClose = () => {
        setOpenD(false);
    };

    React.useEffect(() => {
        if (prof.profile) {
            setIsLoading(false);
        }
    }, [prof.profile]);

    const handleClickForm = (serv) => {        
        navigate('/form/' + serv.id);
    }

    if (wait) {
        return (
            <div style={{
                textAlign: 'center', alignItems: 'center', justifyContent: 'center', display: 'flex',
                width: '100vw',
                height: '85vh'
            }}
            >

            </div>
        )
    }
    if (pagina) {
        if( pagina.regra){
            if( !prof.temAcesso(pagina.regra))return;
        }
        return (
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="persistent"
                anchor="left"
                open={openD}
            >
                <DrawerHeader>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </DrawerHeader>
                <Divider />
                <ContentPage pagina={pagina} />

            </Drawer>
        )
    }
    if (pagina && pagina.codigo) {
        <Box sx={{ flexGrow: 1 }}>
            {pagina.codigo.blocks.map((row, index) => {
                return (
                    <CodeContentPage
                        key={index} bloco={row} pagina={pagina} pageRoot={pageRoot}
                    />
                )
            })}
        </Box>
    }
    return (
        <React.Fragment>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="persistent"
                anchor="left"
                open={openD}
            >
                <DrawerHeader>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </DrawerHeader>
                <Divider />
                {prof.temAcesso("RootMenu") &&
                    <List>
                        <ListItem disablePadding >
                            <ListItemButton href="/gerenciar">
                                <ListItemIcon>
                                    <SettingsIcon />
                                </ListItemIcon>
                                <ListItemText primary="Gerenciarrr" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding >
                            <ListItemButton href="/recursos">
                                <ListItemIcon>
                                    <Inventory />
                                </ListItemIcon>
                                <ListItemText primary="Recurso" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding >
                            <ListItemButton href="/gerenciar/acesso">
                                <ListItemIcon>
                                    <SwitchAccessShortcutAddIcon />
                                </ListItemIcon>
                                <ListItemText primary="Acesso" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding >
                            <ListItemButton href="/gerenciar/acessoUser">
                                <ListItemIcon>
                                    <RuleIcon />
                                </ListItemIcon>
                                <ListItemText primary="Regras do Usuário" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                }
                <Divider />
                <List>
                    <ListItem disablePadding >
                        <ListItemButton onClick={e => setOpenSub(!openSub)}>
                            <ListItemIcon>
                                <SubjectIcon />
                            </ListItemIcon>
                            <ListItemText primary="Solicitações" />
                            {openSub ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={openSub} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {categorias && categorias.map((cat, index) => {
                                if (cat.nome != 'Portal') return
                                return (
                                    <div key={"port_" + index}>
                                        {cat.servicos.map((serv) => (
                                            <ListItemButton sx={{ pl: 4 }}
                                                key={"serv_" + serv.nome}
                                                onClick={() => handleClickForm(serv)}
                                            >
                                                <ListItemIcon>
                                                    <StarBorder />
                                                </ListItemIcon>
                                                <ListItemText primary={serv.nome} />
                                            </ListItemButton>
                                        ))}
                                    </div>
                                )
                            }
                            )}


                        </List>
                    </Collapse>
                </List>
                {prof.temAcesso("portalAdm") &&
                    <React.Fragment>
                        <Divider />
                        <List>
                            <ListItem disablePadding >
                                <ListItemButton href="/gerenciar/tablePortal">
                                    <ListItemIcon>
                                        <AdminPanelSettingsIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Adiministrar Portal" />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </React.Fragment>}
            </Drawer>
        </React.Fragment>
    )
}